import styled from '@emotion/styled';
import { mediaQuery, Spacings } from '@styles/index';
import ArrowBack from '@icon/ArrowBack';

const HeaderContainer = styled.div`
  position: sticky;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 72px;
  background-color: var(--color-base-1);
  box-shadow: inset 0px -1px 0px var(--color-shadow);
  z-index: 2;
  ${mediaQuery.uptoMobile} {
    height: ${Spacings.SPACING_12B};
    position: relative;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1136px;
  height: 100%;
  margin-inline: auto;
  background-color: transparent;
  ${mediaQuery.uptoTablet} {
    width: 728px;
  }
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

const SearchBackArrow = styled.div`
  ${mediaQuery.uptoMobile} {
    display: flex;
    padding: ${Spacings.SPACING_2B};
    margin-left: ${Spacings.SPACING_1B};
  }
  display: none;
  padding: ${Spacings.SPACING_3B};
  background: var(--color-base-1);
`;

const Header = ({ searchInFocus, handleBack }) => {
  return (
    <HeaderContainer id="layout-header">
      <HeaderWrapper>
        {searchInFocus && (
          <SearchBackArrow onClick={handleBack}>
            <ArrowBack size="24px" />
          </SearchBackArrow>
        )}
      </HeaderWrapper>
    </HeaderContainer>
  );
};

export default Header;
